import {isNil} from 'ramda';

import {LabourRateListItem} from '@dms/api/workshop';

import {Nullish, precisionCalculation} from 'shared/web';

/**
 * Derives the selling price fields implied by an hourly labour rate. Returns null when there is no
 * rate to read a price from, so the caller leaves the form untouched.
 */
export const getLabourRateSellingPrices = (
  labourRate: LabourRateListItem | Nullish,
  quantity: number | Nullish
) => {
  const sellingPricePerUnit = labourRate?.rateValue.withoutVat.amount;

  if (isNil(sellingPricePerUnit)) {
    return null;
  }

  return {
    sellingPricePerUnit,
    sellingPrice: precisionCalculation.multiply(sellingPricePerUnit, quantity ?? 0),
  };
};
